import React, { useEffect, useState } from 'react';
import Search from '@guildeducationinc/recess/icons/SearchOutlinedIcon';
import { IconButton, TextInput } from '@guildeducationinc/recess';
import CloseIcon from '@guildeducationinc/recess/icons/CloseIcon';
import { useDebounce } from 'src/utilities/inputUtility';
import { DPPAlgoliaListFacetFilters, getAcademicPartnerIndex } from 'src/clients/Algolia';
import { Skeleton } from 'src/components/UserFacetSkeletonLoader';
import { AcademicPartnerHit } from 'src/queries/user';
import styles from './SearchBar.module.scss';

interface Props {
	query: string;
	setQuery: (val: string) => void;
	setHits: (hits: AcademicPartnerHit[]) => void;
}
export const SearchBar: React.FC<Props> = ({ query, setQuery, setHits }) => {
	const [loading, setLoading] = useState<boolean>(true);
	const debouncedSearchTerm = useDebounce(query, 200);
	const apIndex = getAcademicPartnerIndex();
	useEffect(() => {
		if (debouncedSearchTerm || debouncedSearchTerm === '') {
			apIndex
				.search(query, {
					hitsPerPage: 200,
					facetFilters: DPPAlgoliaListFacetFilters,
				})
				.then(res => {
					setHits((res?.hits as AcademicPartnerHit[]) || []);
					setLoading(false);
				});
		}
	}, [apIndex, debouncedSearchTerm, query, setHits]);

	const onChange = event => {
		setQuery(event.target.value);
	};

	const clickClose = () => {
		setQuery('');
	};

	return (
		<div className='margin--bottom_20 margin--top_32 position--relative width--full' role='search'>
			<Skeleton dataLoading={loading} height={72}>
				<TextInput
					append={
						query ? (
							<IconButton
								appearance='ghost'
								className='margin--0 padding--0'
								icon={<CloseIcon size={24} />}
								label='Close'
								onClick={clickClose}
							/>
						) : null
					}
					className={styles.searchBarInput}
					data-testid='search-input'
					hideLabel={false}
					label='Search name or location'
					onChange={onChange}
					prepend={<Search size={24} />}
					type='search'
					value={query}
				/>
			</Skeleton>
		</div>
	);
};
